import React from "react";
import Index from "../views/dashboard/index";
import MyProfile from "../views/dashboard/myProfile";
import ContactUs from "../views/dashboard/contactUs";
import HelpCenter from "../views/dashboard/helpCenter";
import ClientDashboard from "../views/dashboard/clientDashboard";
import BookingService from "../views/dashboard/bookingService";
import Packages from "../views/dashboard/packages";
import AdsStatus from "../views/dashboard/adsStatus";
import Notifications from "../views/dashboard/notifications";

// Protected Route Component
import ProtectedRoute from "../components/ProtectedRoute";

//app
import UserProfile from "../views/dashboard/app/user-profile";
import UserPrivacySetting from "../views/dashboard/app/user-privacy-setting";
import FriendProfile from "../views/dashboard/app/friend-profile";
import ProfileBadges from "../views/dashboard/app/profile-badges";
import ProfileForums from "../views/dashboard/app/profile-forum";
import Notification from "../views/dashboard/app/notification";
import File from "../views/dashboard/app/file";
import FriendRequest from "../views/dashboard/app/friend-request";
import Todo from "../views/dashboard/app/todo";
import UserAccountSetting from "../views/dashboard/app/user-account-setting";
import UserProfileEdit from "../views/dashboard/app/user-profile-edit";

// icon
import Remixicon from "../views/dashboard/icons/icon-remixicon";
import Lineawesome from "../views/dashboard/icons/icon-lineawesome";
import Fontawesome from "../views/dashboard/icons/icon-fontawesome-5";
import Material from "../views/dashboard/icons/icon-material";

// Form
import FormElement from "../views/dashboard/from/form-element";
import FormValidation from "../views/dashboard/from/form-validation";
import FormSwitch from "../views/dashboard/from/form-switch";
import FormWizard from "../views/dashboard/from/form-wizard";
import FormWizardValidate from "../views/dashboard/from/form-wizard-validate";
import FormWizardVertical from "../views/dashboard/from/form-wizard-vertical";
import FormCheckbox from "../views/dashboard/from/form-checkbox";
import FormRadio from "../views/dashboard/from/form-radio";

// table
import DataTable from "../views/dashboard/table/data-table";
import TableBasic from "../views/dashboard/table/tables-basic";
import TableEditable from "../views/dashboard/table/table-editable";

// blog pages
import BlogGrid from "../views/dashboard/blog/bloggrid";
import BlogList from "../views/dashboard/blog/bloglist";
import BlogDetail from "../views/dashboard/blog/blogdetail";

// Email
import Email from "../views/dashboard/email/email";
import EmailCompose from "../views/dashboard/email/email-compose";

//ui-kit
import UiAlerts from "../views/dashboard/ui-kit/ui-alerts";
import UiBadges from "../views/dashboard/ui-kit/ui-badges";
import UiBreadcrumbs from "../views/dashboard/ui-kit/ui-breadcrumb";
import UiButtons from "../views/dashboard/ui-kit/ui-buttons";
import UiCards from "../views/dashboard/ui-kit/ui-cards";
import UiCarousels from "../views/dashboard/ui-kit/ui-carousel";
import UiColors from "../views/dashboard/ui-kit/ui-color";
import UiDropdowns from "../views/dashboard/ui-kit/ui-dropdowns";
import UiEmbedVideos from "../views/dashboard/ui-kit/ui-embed-video";
import UiGrids from "../views/dashboard/ui-kit/ui-grid";
import UiImages from "../views/dashboard/ui-kit/ui-images";
import UiListGroups from "../views/dashboard/ui-kit/ui-list-groups";
import UiModals from "../views/dashboard/ui-kit/ui-modal";
import UiNotifications from "../views/dashboard/ui-kit/ui-notifications";
import UiOffcanvas from "../views/dashboard/ui-kit/ui-offcanvas";
import UiPaginations from "../views/dashboard/ui-kit/ui-pagination";
import UiPopovers from "../views/dashboard/ui-kit/ui-popovers";
import UiProgressbars from "../views/dashboard/ui-kit/ui-progressbars";
import UiTabs from "../views/dashboard/ui-kit/ui-tabs";
import UiTooltips from "../views/dashboard/ui-kit/ui-tooltips";
import UiTypographys from "../views/dashboard/ui-kit/ui-typography";

// extrapages
import Pricing from "../views/dashboard/extrapages/pricing";
import Pricing1 from "../views/dashboard/extrapages/pricing1";
import Timeline from "../views/dashboard/extrapages/timeline";
import Invoice from "../views/dashboard/extrapages/invoice";
import Faq from "../views/dashboard/extrapages/faq";
import PrivacyPolicy from "../views/dashboard/extrapages/privacy-policy";
import TermsofService from "../views/dashboard/extrapages/terms-of-service";
import BlankPage from "../views/dashboard/extrapages/blankpage";
import Admin from "../views/dashboard/app/admin";

export const DefaultRouter = [
  {
    path: "myProfile",
    element: <ProtectedRoute><MyProfile /></ProtectedRoute>,
  },
  {
    path: "contactUs",
    element: <ProtectedRoute><ContactUs /></ProtectedRoute>,
  },
  {
    path: "helpCenter",
    element: <ProtectedRoute><HelpCenter /></ProtectedRoute>,
  },
  {
    path: "bookingService",
    element: <ProtectedRoute><BookingService /></ProtectedRoute>,
  },
  {
    path: "packages",
    element: <ProtectedRoute><Packages /></ProtectedRoute>,
  },
  {
    path: "adsStatus",
    element: <ProtectedRoute><AdsStatus /></ProtectedRoute>,
  },
  {
    path: "app/profile",
    element: <ProtectedRoute><UserProfile /></ProtectedRoute>,
  },
  {
    path: "app/user-privacy-setting",
    element: <ProtectedRoute><UserPrivacySetting /></ProtectedRoute>,
  },
  {
    path: "app/friend-profile",
    element: <ProtectedRoute><FriendProfile /></ProtectedRoute>,
  },
  {
    path: "app/profile-badges",
    element: <ProtectedRoute><ProfileBadges /></ProtectedRoute>,
  },
  {
    path: "app/profile-forum",
    element: <ProtectedRoute><ProfileForums /></ProtectedRoute>,
  },
  {
    path: "app/notification",
    element: <ProtectedRoute><Notification /></ProtectedRoute>,
  },
  {
    path: "app/file",
    element: <ProtectedRoute><File /></ProtectedRoute>,
  },
  {
    path: "app/friend-request",
    element: <ProtectedRoute><FriendRequest /></ProtectedRoute>,
  },
  {
    path: "app/todo",
    element: <ProtectedRoute><Todo /></ProtectedRoute>,
  },
  {
    path: "app/user-account-setting",
    element: <ProtectedRoute><UserAccountSetting /></ProtectedRoute>,
  },
  {
    path: "app/user-profile-edit",
    element: <ProtectedRoute><UserProfileEdit /></ProtectedRoute>,
  },
  {
    path: "icon/fontawesome-5",
    element: <ProtectedRoute><Fontawesome /></ProtectedRoute>,
  },
  {
    path: "icon/remixicon",
    element: <ProtectedRoute><Remixicon /></ProtectedRoute>,
  },
  {
    path: "icon/lineawesome",
    element: <ProtectedRoute><Lineawesome /></ProtectedRoute>,
  },
  {
    path: "icon/material",
    element: <ProtectedRoute><Material /></ProtectedRoute>,
  },
  {
    path: "form/form-elemen",
    element: <ProtectedRoute><FormElement /></ProtectedRoute>,
  },
  {
    path: "form/form-validation",
    element: <ProtectedRoute><FormValidation /></ProtectedRoute>,
  },
  {
    path: "form/form-switch",
    element: <ProtectedRoute><FormSwitch /></ProtectedRoute>,
  },
  {
    path: "form/form-wizard",
    element: <ProtectedRoute><FormWizard /></ProtectedRoute>,
  },
  {
    path: "form/form-wizard-validate",
    element: <ProtectedRoute><FormWizardValidate /></ProtectedRoute>,
  },
  {
    path: "form/form-wizard-vertical",
    element: <ProtectedRoute><FormWizardVertical /></ProtectedRoute>,
  },
  {
    path: "form/form-checkbox",
    element: <ProtectedRoute><FormCheckbox /></ProtectedRoute>,
  },
  {
    path: "form/form-radio",
    element: <ProtectedRoute><FormRadio /></ProtectedRoute>,
  },
  {
    path: "blog/blog-grid",
    element: <ProtectedRoute><BlogGrid /></ProtectedRoute>,
  },
  {
    path: "blog/blog-list",
    element: <ProtectedRoute><BlogList /></ProtectedRoute>,
  },
  {
    path: "blog/blog-detail",
    element: <ProtectedRoute><BlogDetail /></ProtectedRoute>,
  },
  {
    path: "Email/email",
    element: <ProtectedRoute><Email /></ProtectedRoute>,
  },
  {
    path: "Email/email-compose",
    element: <ProtectedRoute><EmailCompose /></ProtectedRoute>,
  },
  {
    path: "extrapages/pages-pricing",
    element: <ProtectedRoute><Pricing /></ProtectedRoute>,
  },
  {
    path: "extrapages/pages-pricing-one",
    element: <ProtectedRoute><Pricing1 /></ProtectedRoute>,
  },
  {
    path: "extrapages/pages-timeline",
    element: <ProtectedRoute><Timeline /></ProtectedRoute>,
  },
  {
    path: "extrapages/pages-invoice",
    element: <ProtectedRoute><Invoice /></ProtectedRoute>,
  },
  {
    path: "extrapages/pages-faq",
    element: <ProtectedRoute><Faq /></ProtectedRoute>,
  },
  {
    path: "extrapages/privacy-policy",
    element: <ProtectedRoute><PrivacyPolicy /></ProtectedRoute>,
  },
  {
    path: "extrapages/terms-of-service",
    element: <ProtectedRoute><TermsofService /></ProtectedRoute>,
  },
  {
    path: "extrapages/blankpage",
    element: <ProtectedRoute><BlankPage /></ProtectedRoute>,
  },
  {
    path: "app/admin",
    element: <ProtectedRoute><Admin /></ProtectedRoute>,
  },
  {
    path: "helpCenter",
    element: <ProtectedRoute><HelpCenter /></ProtectedRoute>,
  },
  {
    path: "summary",
    element: <ProtectedRoute><ClientDashboard /></ProtectedRoute>,
  },
  {
    path: "bookingService",
    element: <ProtectedRoute><BookingService /></ProtectedRoute>,
  },
  {
    path: "packages",
    element: <ProtectedRoute><Packages /></ProtectedRoute>,
  },
  {
    path: "adsStatus",
    element: <ProtectedRoute><AdsStatus /></ProtectedRoute>,
  },
  {
    path: "notifications",
    element: <ProtectedRoute><Notifications /></ProtectedRoute>,
  },

  // Ui-kit
  {
    path: "ui-kit/ui-alerts",
    element: <ProtectedRoute><UiAlerts /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-badges",
    element: <ProtectedRoute><UiBadges /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-breadcrumb",
    element: <ProtectedRoute><UiBreadcrumbs /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-buttons",
    element: <ProtectedRoute><UiButtons /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-cards",
    element: <ProtectedRoute><UiCards /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-carousel",
    element: <ProtectedRoute><UiCarousels /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-color",
    element: <ProtectedRoute><UiColors /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-dropdowns",
    element: <ProtectedRoute><UiDropdowns /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-embed-video",
    element: <ProtectedRoute><UiEmbedVideos /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-grid",
    element: <ProtectedRoute><UiGrids /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-images",
    element: <ProtectedRoute><UiImages /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-list-groups",
    element: <ProtectedRoute><UiListGroups /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-modal",
    element: <ProtectedRoute><UiModals /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-notifications",
    element: <ProtectedRoute><UiNotifications /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-offcanvas",
    element: <ProtectedRoute><UiOffcanvas /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-pagination",
    element: <ProtectedRoute><UiPaginations /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-popovers",
    element: <ProtectedRoute><UiPopovers /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-progressbars",
    element: <ProtectedRoute><UiProgressbars /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-tabs",
    element: <ProtectedRoute><UiTabs /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-tooltips",
    element: <ProtectedRoute><UiTooltips /></ProtectedRoute>,
  },
  {
    path: "ui-kit/ui-typography",
    element: <ProtectedRoute><UiTypographys /></ProtectedRoute>,
  },
  // Table
  {
    path: "table/data-table",
    element: <ProtectedRoute><DataTable /></ProtectedRoute>,
  },
  {
    path: "table/tables-basic",
    element: <ProtectedRoute><TableBasic /></ProtectedRoute>,
  },
  {
    path: "table/table-editable",
    element: <ProtectedRoute><TableEditable /></ProtectedRoute>,
  },
  // Form
  {
    path: "form/form-element",
    element: <ProtectedRoute><FormElement /></ProtectedRoute>,
  },
  {
    path: "form/form-validation",
    element: <ProtectedRoute><FormValidation /></ProtectedRoute>,
  },
  {
    path: "form/form-switch",
    element: <ProtectedRoute><FormSwitch /></ProtectedRoute>,
  },
  {
    path: "form/form-wizard",
    element: <ProtectedRoute><FormWizard /></ProtectedRoute>,
  },
  {
    path: "form/form-wizard-validate",
    element: <ProtectedRoute><FormWizardValidate /></ProtectedRoute>,
  },
  {
    path: "form/form-wizard-vertical",
    element: <ProtectedRoute><FormWizardVertical /></ProtectedRoute>,
  },
  {
    path: "form/form-checkbox",
    element: <ProtectedRoute><FormCheckbox /></ProtectedRoute>,
  },
  {
    path: "form/form-radio",
    element: <ProtectedRoute><FormRadio /></ProtectedRoute>,
  },
];
